const getById = (list, id) => list.find((item) => item.id === id);

export { getById };
